import { useBrandsDataQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { useInvoiceStore } from "../store";

export const useFetchBrandsData = () => {
  const store = useInvoiceStore();

  const { refetch, loading } = useBrandsDataQuery({
    notifyOnNetworkStatusChange: true,
    variables: {
      brand_ids: store.form.brand_ids.value,
      brandCount: store.form.brand_ids.value.length + 1,
    },
    onCompleted(data) {
      if (data) {
        store.setSelectedBrands(data);
      }
    },
    ...onError(),
  });

  store.selectedBrandsRefetch = refetch;
  store.setSelectedBrandsLoading(loading);
};
